import React from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = (prop) => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (e) => {
    const newLang = e.target.value;
    i18n.changeLanguage(newLang);
  };

  return (
    <select
      style={{
        marginTop: `${prop.size}px`,
      }}
      value={i18n.language}
      onChange={handleLanguageChange}
      className="language-switcher"
    >
      <option value="uz">O'zbekcha</option>
      <option value="en">English</option>
      <option value="ru">Русский</option>
    </select>
  );
};

export default LanguageSwitcher;
